// extracted by mini-css-extract-plugin
var _1 = "NotificationDot-module__animateUploadProgressBarWidth--o_Lks";
var _2 = "NotificationDot-module__animatedBackground--tqeve";
var _3 = "NotificationDot-module__dot--tqJlW";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "dot" }
